import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ImpactChartData } from '../../interfaces';
import { Observable } from 'rxjs';
import * as fromSelectors from '../../fl/@store/selectors';
import { Store } from '@ngrx/store';
import { CHART_NO_TOOLBAR_CONFIG } from '../plotly-chart-config';

@Component({
  selector: 'app-treemap-chart',
  standalone: false,
  templateUrl: './treemap-chart.component.html',
  styleUrl: './treemap-chart.component.scss'
})
export class TreemapChartComponent implements OnChanges, OnInit {

    constructor(private store: Store) {}

    @Input() data!: ImpactChartData[];
    @Output() clickedOnNodeEvent = new EventEmitter<string>();

    @ViewChild('chart') chart!: ElementRef;
    title = 'plotly-treemap-example';
    selectedMbu$: Observable<string> = this.store.select(fromSelectors.selectedMbu);

    public graph = {
        data: [
            {
                type: 'treemap',
                labels: [] as string[],
                parents: [] as string[],
                values: [] as number[],
                customdata: [] as number[][],
                texttemplate: '<br><b>&nbsp;%{label}</b><br><br>&nbsp;Percentage Change: %{customdata[0]:.2f} %<br>&nbsp;Number of products: %{customdata[1]}<br>&nbsp;Margin weighted impact: U$ %{customdata[2]}M<br>',
                textfont: {
                    color: [] as string[],
                    size: 12
                },
                marker: {
                    colors: [] as string[],
                    showscale: false,
                    line: {
                        width: 2,
                        color: 'white'
                    }
                },
            }
        ],
        layout: {
            title: 'Sample Plotly Treemap',
            height: 310,
            autosize: true,
            margin: {
                l: 0,             // Remove left margin
                r: 0,             // Remove right margin
                t: 5,            // Keep some top margin for title
                b: 0,             // Remove bottom margin
                pad: 0            // Remove padding
            },
            pathbar: {
                visible: true
            },
            paper_bgcolor: 'rgba(0,0,0,0)',  // Transparent background
            plot_bgcolor: 'rgba(0,0,0,0)',   // Transparent plot area
            annotations: [] as any[]
        },
        config: CHART_NO_TOOLBAR_CONFIG
    };

    ngOnInit(): void {
            this.graph.data[0].labels = this.data.map((elem) => elem.label);
            this.graph.data[0].parents = this.data.map(elem => elem.parent);
            this.graph.data[0].values = this.data.map(elem => Math.round(elem.size/1000000));
            this.graph.data[0].customdata = this.data.map(elem => [elem.value * 100, elem.numberOfRecords, Math.round(elem.size/1000000)]);

            const colorPalette = ['#FFD700', '#B4D405', '#ED8B00', '#890C58'];

            const colors = this.data.map(elem => {
                if (elem.value < 0.02) return colorPalette[1];
                else if (elem.value < 0.05) return colorPalette[0];
                else if (elem.value < 0.08) return colorPalette[2];
                else return colorPalette[3];
            });

            const textColors = colors.map(color => this.getContrastingColor(color));

            this.graph.data[0].marker.colors = colors;
            this.graph.data[0].textfont.color = textColors;
    }

    ngOnChanges(changes: SimpleChanges): void {
    }

  getContrastingColor(hexColor: string): string {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 255000;

    return brightness >= 0.5 ? 'black' : 'white';
  }

  handleTreemapClick(event: any) {
    if (event && event.points && event.points.length > 0) {
        const clickedPoint = event.points[0];
        const nodeName = clickedPoint.label;
        this.clickedOnNodeEvent.emit(nodeName);
    }
  }
}
